import React from "react";
import Select from "react-select";
import copy from "copy-to-clipboard";

import LinkLike from "./link-like.jsx";
import UserStore from "../../stores/UserStore";
import UserActions from "../../actions/UserActions";
import InlineNoticeLabel from "./inline-notice-label.jsx";
import { IconButton } from "material-ui";
import PermIdentityIcon from "material-ui/svg-icons/action/perm-identity";
import SupervisorAccountIcon from "material-ui/svg-icons/action/supervisor-account";
import CopyIcon from "material-ui/svg-icons/content/content-copy";

import GlobalNotificationActions from "../../actions/GlobalNotificationActions";

class GodModeControl extends React.PureComponent {
  constructor(props) {
    super(props);
    this.setUser = this.setUser.bind(this);
    this.copyLink = this.copyLink.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentDidMount() {
    UserActions.fetchRoles.defer();
  }

  setUser(id) {
    if (!id) {
      return;
    }

    // If the current URL looks like it has an ID in it (e.g. event_buckets/xxxxx), redirect
    // back to the welcome screen. If not and it's a generic page (e.g. billing hub),
    // keep the user on the page even when changing accounts.
    const currentPath = window.location.pathname;
    if (currentPath.match(/[a-f\d]{24}/i)) {
      this.context.router.push("/welcome");
    } else {
      this.context.router.push("/blank");
      setTimeout(() => this.context.router.push(currentPath), 50);
    }

    UserActions.setGodUser(id);
  }

  copyLink() {
    const url = new URL(window.location.href);
    url.searchParams.append("_god_become_user", this.props.activeGodUser);
    copy(url.toString());
    GlobalNotificationActions.notify.defer(
      "God one-click link copied successfully!"
    );
  }

  render() {
    let {
      condensedUsers,
      activeGodUser,
      activeGodRole,
      roles,
      godStealthMode,
      style
    } = this.props;

    return (
      <div
        style={Object.assign({}, style, {
          width: "auto",
          display: "inline-flex",
          alignItems: "center"
        })}
      >
        {!godStealthMode ? (
          <IconButton
            tooltip="Copy one-click link"
            onTouchTap={() => this.copyLink()}
            style={{ marginRight: -10 }}
            iconStyle={{ transform: "scale(0.8)" }}
          >
            <CopyIcon color="#fff" />
          </IconButton>
        ) : null}
        <IconButton
          tooltip={
            godStealthMode ? "Disable stealth mode" : "Enable stealth mode"
          }
          onTouchTap={() => UserActions.godSetStealthMode(!godStealthMode)}
          style={{ marginRight: 5 }}
        >
          {godStealthMode ? (
            <PermIdentityIcon color="#fff" />
          ) : (
            <SupervisorAccountIcon color="#fff" />
          )}
        </IconButton>
        <div style={{ flex: 1 }}>
          {godStealthMode ? (
            <div
              style={{
                fontWeight: "bold",
                color: "#fff",
                flex: 1,
                textAlign: "left",
                fontSize: "1.1em",
                marginRight: 5
              }}
            >
              <div>
                {condensedUsers.find(user => activeGodUser === user.id)
                  ? condensedUsers.find(user => activeGodUser === user.id).organization
                  : "Unknown"}
              </div>
              <select
                style={{
                  fontSize: "0.8em",
                  marginTop: 4,
                  backgroundColor: "transparent",
                  color: "#fff",
                  border: "1px solid #fff",
                  borderRadius: 5
                }}
                value={activeGodRole || "admin"}
                onChange={e => {
                  UserActions.setGodRole(e.target.value);
                }}
              >
                {roles &&
                  Object.keys(roles).map(k => {
                    return (
                      <option key={k} value={k}>
                        {roles[k].label}
                      </option>
                    );
                  })}
              </select>
            </div>
          ) : (
            <Select
              style={{ minWidth: 220 }}
              clearable={false}
              tabIndex="-1"
              value={activeGodUser}
              noResultsText="Type to search..."
              filterOption={(o, f) =>
                f.length > 2 &&
                o._raw.indexOf((f || "").trim().toLowerCase()) !== -1
              }
              options={condensedUsers
                .map(user => {
                  return {
                    _type: user.type || "festival_organizer",
                    _raw: (user.organization || "").toLowerCase(),
                    label: (
                      <span>
                        {user.organization}{" "}
                        {user.type === "content_creator" ? (
                          <InlineNoticeLabel
                            style={{ whiteSpace: "nowrap" }}
                            label="Content Creator"
                          />
                        ) : null}
                      </span>
                    ),
                    value: user.id
                  };
                })
                .sort(
                  (a, b) =>
                    -a._type.localeCompare(b._type) ||
                    a._raw.localeCompare(b._raw)
                )}
              onChange={e => this.setUser(e.value)}
            />
          )}
        </div>
      </div>
    );
  }
}

export default GodModeControl;



// WEBPACK FOOTER //
// ./src/app/components/partials/god-mode-control.jsx